import { defineComponent as _defineComponent } from 'vue'
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import QuickSearchItem from '@/models/metrics/quickSearchItem';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import {
  CompositeWidgetDefinition,
  CompositeWidgetEntry,
  WidgetEntry,
} from '@/models/Charts/compositeWidgetDefinition';
import LayoutGrid from '@/views/dashboard/LayoutGrid.vue';
import {
  availableDashboardLayouts,
  DashboardLayout,
} from '@/models/Charts/dashboardDefinition';
import { indexedWidgetDefinitions } from '@/utils/misc';
import { useI18n } from '@/composables/i18n';
import { onBeforeMount, ref } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'DetailedCustomerView',
  props: {
    selectedTimeFilter: null,
    selectedDateGrouping: null,
    selection: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  selectedTimeFilter: [string, string];
  selectedDateGrouping: FilterTimeAxisSpanEnum;
  selection: QuickSearchItem;
};





const { t } = useI18n();

const gridLayout = availableDashboardLayouts[DashboardLayout.TwoByThree];

const widgetDefinitions = ref<WidgetEntry[]>([]);
const loading = ref(false);

onBeforeMount(() => {
  widgetDefinitions.value = createWidgetDefinitions();
});

function createWidgetDefinitions(): WidgetEntry[] {
  return indexedWidgetDefinitions([
    new WidgetDefinition(
      WidgetEnum.QuotesTopQuotedMaterialsTimeline,
      [],
      props.selectedTimeFilter,
      [],
      undefined,
      props.selectedDateGrouping,
    ),
    new CompositeWidgetDefinition(
      new CompositeWidgetEntry(
        new WidgetDefinition(
          WidgetEnum.QuotesMap,
          [],
          props.selectedTimeFilter,
          [],
          undefined,
          props.selectedDateGrouping,
        ),
        'tag',
      ),
      new CompositeWidgetEntry(
        new WidgetDefinition(
          WidgetEnum.QuotesConvertedMap,
          [],
          props.selectedTimeFilter,
          [],
          undefined,
          props.selectedDateGrouping,
        ),
        'check',
      ),
    ),
    new WidgetDefinition(
      WidgetEnum.QuotesConversionRatesGauge,
      [],
      props.selectedTimeFilter,
      [],
      undefined,
      props.selectedDateGrouping,
    ),
    new WidgetDefinition(
      WidgetEnum.QuotesCustomerEvolution,
      [],
      props.selectedTimeFilter,
      [],
      undefined,
      props.selectedDateGrouping,
    ),
    new WidgetDefinition(
      WidgetEnum.QuotesFiguresDetailed,
      [],
      props.selectedTimeFilter,
      [],
      undefined,
      props.selectedDateGrouping,
    ),
    new WidgetDefinition(
      WidgetEnum.QuotesTopSalespeopleDetailed,
      [],
      props.selectedTimeFilter,
      [],
      undefined,
      props.selectedDateGrouping,
    ),
  ]);
}

function updateWidgetDefinition(
  index: number,
  newWidgetDefinition: WidgetEntry,
) {
  // It's necessary because 'splice' triggers reactivity
  // It appears that Vue is able to track the removal and insertion of the element, not just the direct change in the index.
  widgetDefinitions.value.splice(index, 1, newWidgetDefinition);
}

function getWidgetHelpPosition(
  index: number | undefined,
): 'is-bottom-left' | 'is-bottom-right' {
  return index === 2 || index === 5 ? 'is-bottom-left' : 'is-bottom-right';
}

return { __sfc: true,props, emit, t, gridLayout, widgetDefinitions, loading, createWidgetDefinitions, updateWidgetDefinition, getWidgetHelpPosition, WidgetContainer, LayoutGrid }
}

})